var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mit_bl._Kreislinie",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.6;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill:none;}.cls-2{clip-path:url(#clippath-2);}.cls-8{fill:#fff;}.cls-3,.cls-7{stroke:#009fe3;}.cls-9{fill:#009fe3;}.cls-5{clip-path:url(#clippath);}.cls-6{clip-path:url(#clippath-1);}.cls-7{stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 150,
    height: 150
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 150,
    height: 150
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.07,
    y: 65.72,
    width: 42.79,
    height: 32.56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FAQ"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m104.79,80.95c0-5.33-6.41-9.64-14.32-9.64s-14.32,4.32-14.32,9.64c0,3.97,3.57,7.38,8.67,8.86l-.94,6.67,5.92-5.91c.22,0,.45.02.67.02,7.91,0,14.32-4.32,14.32-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.79,80.95c0-5.33-6.41-9.64-14.32-9.64s-14.32,4.32-14.32,9.64c0,3.97,3.57,7.38,8.67,8.86l-.94,6.67,5.92-5.91c.22,0,.45.02.67.02,7.91,0,14.32-4.32,14.32-9.64Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 75,
    cy: 75,
    r: 68.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m86.64,69.56c0-7.7-9.27-13.95-20.71-13.95s-20.71,6.24-20.71,13.95,9.22,13.91,20.62,13.94l5.89,5.89-.89-6.3c9.06-1.49,15.8-6.97,15.8-13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m72.13,66.29c0-.38.09-.68.27-.91.18-.23.42-.34.73-.34s.55.11.74.34c.19.23.28.53.28.91v6.11c0,.38-.09.68-.28.91-.19.23-.43.35-.74.35s-.55-.11-.73-.35c-.18-.23-.27-.53-.27-.91v-6.11Zm1-3.45c-.7,0-1.32.15-1.86.46-.54.31-.96.75-1.25,1.31-.3.56-.44,1.21-.44,1.95v5.56c0,.85.2,1.58.59,2.2.39.62.94,1.05,1.63,1.31.05.01.07.04.07.09v1.55c0,.06.02.11.06.15s.09.06.15.06h2.13c.06,0,.11-.02.15-.06s.06-.09.06-.15v-1.55s.02-.08.07-.09c.69-.25,1.23-.69,1.63-1.31.39-.62.59-1.35.59-2.2v-5.56c0-1.11-.33-2.01-.98-2.7-.65-.68-1.52-1.03-2.6-1.03m-9.14,8.76l.82-4.96s.03-.05.06-.05.04.02.05.05l.85,4.96c.01.06-.01.09-.07.09h-1.64s-.07-.03-.07-.09m2.69,4.11h2.18c.13,0,.2-.05.2-.16l-.02-.07-2.65-12.29c-.02-.13-.1-.2-.24-.2h-2.45c-.13,0-.21.07-.24.2l-2.67,12.29c-.04.16.02.24.18.24h2.13c.15,0,.22-.07.24-.2l.29-1.74c0-.06.04-.09.11-.09h2.31c.07,0,.11.03.11.09l.29,1.74c.01.13.09.2.24.2m-5.6-10.74v-1.76c0-.06-.02-.11-.06-.15-.04-.04-.09-.06-.15-.06h-6.22c-.06,0-.11.02-.15.06-.04.04-.06.09-.06.15v12.29c0,.06.02.11.06.15.04.04.09.06.15.06h2.13c.06,0,.11-.02.15-.06.04-.04.06-.09.06-.15v-4.96c0-.06.03-.09.09-.09h2.16c.06,0,.11-.02.15-.06s.06-.09.06-.15v-1.76c0-.06-.02-.11-.06-.15-.04-.04-.09-.06-.15-.06h-2.16c-.06,0-.09-.03-.09-.09v-2.87c0-.06.03-.09.09-.09h3.78c.06,0,.11-.02.15-.06.04-.04.06-.09.06-.15"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.4118f5e0ef379c72a3f890f47983526f.svg";
export { ForwardRef as ReactComponent };